import React, { useEffect, useState } from "react";
import { FiMail, FiMapPin } from "react-icons/fi";
import siteConfig from "../config/siteConfig";
import "../css/contactus.scss";

function Contact() {
  const [form, setForm] = useState({ firstName: "", lastName: "", email: "", order: "", subject: "Product advice", message: "" });
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState("idle");

  useEffect(() => {
    document.title = `Contact — ${siteConfig.brandName}`;
  }, []);

  const update = (event) => {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
    if (errors[name]) setErrors((current) => ({ ...current, [name]: "" }));
  };

  const submit = (event) => {
    event.preventDefault();
    const nextErrors = {};
    if (!form.firstName.trim()) nextErrors.firstName = "Enter your first name.";
    if (!form.lastName.trim()) nextErrors.lastName = "Enter your last name.";
    if (!/^\S+@\S+\.\S+$/.test(form.email)) nextErrors.email = "Enter a valid email address.";
    if (form.message.trim().length < 10) nextErrors.message = "Your message must contain at least 10 characters.";
    if (Object.keys(nextErrors).length) {
      setErrors(nextErrors);
      return;
    }
    setStatus("sending");
    window.setTimeout(() => {
      setStatus("sent");
      setForm({ firstName: "", lastName: "", email: "", order: "", subject: "Product advice", message: "" });
    }, 650);
  };

  return (
    <main className="contact">
      <header className="contact-heading shell">
        <p className="eyebrow">Have a question?</p>
        <h1>Get in touch.</h1>
        <p>Our team replies Monday to Friday, usually within two business days.</p>
      </header>

      <div className="contact-layout shell">
        <aside className="contact-details">
          <div><FiMail /><span><small>Email</small><a href={`mailto:${siteConfig.email}`}>{siteConfig.email}</a></span></div>
          <div><FiMapPin /><span><small>Address</small><p>{siteConfig.address}</p></span></div>
          <p className="contact-details__note">For a return, always wait for our confirmation before sending your parcel. We will provide the correct process and return address.</p>
        </aside>

        <form className="contact-form" onSubmit={submit} noValidate>
          {status === "sent" && <div className="contact-success" role="status">Thank you! Your message has been prepared. Our team will reply by email.</div>}
          <div className="contact-form__row">
            <label><span>First name *</span><input name="firstName" value={form.firstName} onChange={update} aria-invalid={Boolean(errors.firstName)} />{errors.firstName && <small>{errors.firstName}</small>}</label>
            <label><span>Last name *</span><input name="lastName" value={form.lastName} onChange={update} aria-invalid={Boolean(errors.lastName)} />{errors.lastName && <small>{errors.lastName}</small>}</label>
          </div>
          <label><span>Email *</span><input type="email" name="email" value={form.email} onChange={update} aria-invalid={Boolean(errors.email)} />{errors.email && <small>{errors.email}</small>}</label>
          <div className="contact-form__row">
            <label><span>Order number</span><input name="order" value={form.order} onChange={update} placeholder="TV-000000" /></label>
            <label><span>Subject</span><select name="subject" value={form.subject} onChange={update}><option>Product advice</option><option>Order tracking</option><option>Delivery</option><option>Return or exchange</option><option>Other enquiry</option></select></label>
          </div>
          <label><span>Message *</span><textarea name="message" value={form.message} onChange={update} rows="7" aria-invalid={Boolean(errors.message)} placeholder="How can we help?" />{errors.message && <small>{errors.message}</small>}</label>
          <button className="btn" type="submit" disabled={status === "sending"}>{status === "sending" ? "Sending..." : "Send message"}</button>
        </form>
      </div>
    </main>
  );
}

export default Contact;
